import { fromEvent as observableFromEvent, Subject } from 'rxjs';
import { bufferToggle, debounceTime, distinctUntilChanged, filter, map, takeUntil } from 'rxjs/operators';
import { AfterViewInit, ChangeDetectorRef, ElementRef, EventEmitter, OnChanges, OnDestroy, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import chaining from '../../../core/helpers/chaining';
import { FlyToCartService } from '../../services/fly-to-cart.service';
var QuantityPickerAnimatedComponent = /** @class */ (function () {
    function QuantityPickerAnimatedComponent(detectorRef, flyToCartSvc) {
        var _this = this;
        this.detectorRef = detectorRef;
        this.flyToCartSvc = flyToCartSvc;
        this.onDestroyed = new Subject();
        this.onChange = new Subject();
        this.debouncer = new Subject();
        this.control = new FormControl();
        this.focused = false;
        this.state = 'default';
        this.animationPossible = false;
        this.minQuantity = 0;
        this.stepping = 1;
        this.deferToBlur = false;
        this.zeroAllowed = true;
        this.quantityEditPermission = false;
        this.alignment = 'flex-end';
        this.mode = 'regular';
        this.quantityChanged = new EventEmitter();
        this.debouncer
            .pipe(debounceTime(500))
            .subscribe(function (val) { return _this.quantityChanged.emit(val); });
    }
    QuantityPickerAnimatedComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        var input = this.inputElement.nativeElement;
        var inputVal$ = this.control.valueChanges.pipe(distinctUntilChanged(null, function (value) { return value; }), map(function (value) { return _this.isInteger ? value : _this.minQuantity; }));
        var inputFocus$ = observableFromEvent(input, 'focus').pipe(takeUntil(this.onDestroyed));
        var inputBlur$ = observableFromEvent(input, 'blur').pipe(takeUntil(this.onDestroyed));
        inputFocus$.subscribe(function () {
            _this.focused = true;
            _this.detectorRef.detectChanges();
        });
        inputBlur$.subscribe(function () {
            _this.focused = false;
        });
        this.onChange.subscribe(function (val) { return _this.control.setValue(val, { emitEvent: false }); });
        if (this.deferToBlur)
            inputVal$ = inputVal$.pipe(bufferToggle(inputFocus$, function () { return inputBlur$; }), filter(function (values) { return !!(values && values.length); }), map(function (values) { return values[values.length - 1]; }));
        inputBlur$.subscribe(function () {
            _this.calculateMod();
        });
        this.onChange
            .subscribe(function (value) {
            value = _this.quantityEditPermission
                ? value
                : value - (value % _this.stepping);
            if (value < 0) {
                _this.makeInactive();
                _this.debouncer.next({
                    quantity: 0,
                    isEdited: false
                });
                _this.control.setValue(0);
                _this.makeInactive();
            }
            if (value === 0 && _this.zeroAllowed) {
                _this.debouncer.next({
                    quantity: value,
                    isEdited: _this.quantityEditPermission && ((_this.currentQuantity < _this.minQuantity) || (_this.currentQuantity % _this.stepping !== 0))
                });
                _this.makeInactive();
            }
            else if (_this.currentQuantity <= _this.minQuantity) {
                _this.control.setValue(_this.minQuantity);
                _this.debouncer.next({
                    quantity: _this.minQuantity,
                    isEdited: _this.quantityEditPermission && ((_this.currentQuantity < _this.minQuantity) || (_this.currentQuantity % _this.stepping !== 0))
                });
            }
            if (value > 0) {
                if (_this.animationPossible)
                    _this.flyToCartSvc.animateFlyToCart(_this.itemId, _this.source);
                _this.debouncer.next({
                    quantity: value,
                    isEdited: _this.quantityEditPermission && ((_this.currentQuantity < _this.minQuantity) || (_this.currentQuantity % _this.stepping !== 0))
                });
            }
            _this.detectorRef.detectChanges();
        });
    };
    QuantityPickerAnimatedComponent.prototype.ngOnChanges = function (changes) {
        if (chaining(changes, 'value.currentValue') !== this.control.value) {
            this.control.setValue(isNaN(chaining(this, 'value')) ? chaining(this, 'value.quantity') : chaining(this, 'value'));
            if (chaining(changes, 'value.currentValue') === 0)
                this.makeInactive();
        }
        if (this.control.value)
            this.makeActive();
        this.detectorRef.detectChanges();
    };
    QuantityPickerAnimatedComponent.prototype.ngOnDestroy = function () {
        this.onDestroyed.next();
        this.onDestroyed.complete();
    };
    Object.defineProperty(QuantityPickerAnimatedComponent.prototype, "isInteger", {
        get: function () {
            return Number.isInteger(this.currentQuantity);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(QuantityPickerAnimatedComponent.prototype, "currentQuantity", {
        get: function () {
            return Number(this.control.value);
        },
        enumerable: true,
        configurable: true
    });
    QuantityPickerAnimatedComponent.prototype.change = function (e, change) {
        if (change > 0)
            this.animationPossible = true;
        else
            this.animationPossible = false;
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        change = change * this.stepping;
        this.detectorRef.detectChanges();
        this.onChange.next(Number(this.control.value) + change);
    };
    QuantityPickerAnimatedComponent.prototype.onSubmit = function (e) {
        this.inputElement.nativeElement.blur();
    };
    QuantityPickerAnimatedComponent.prototype.calculateMod = function () {
        var mod = this.control.value % this.stepping;
        if ((mod >= 0) && !this.quantityEditPermission)
            this.onChange.next(this.control.value - mod);
        else if (this.quantityEditPermission)
            this.onChange.next(this.control.value);
    };
    QuantityPickerAnimatedComponent.prototype.makeActive = function (e) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }
        if (this.state !== 'active')
            this.state = 'active';
        if (!this.control.value)
            this.change(e, 1);
    };
    QuantityPickerAnimatedComponent.prototype.makeInactive = function () {
        this.state = 'default';
        this.detectorRef.detectChanges();
    };
    QuantityPickerAnimatedComponent.prototype.prevent = function (e) {
        e.stopPropagation();
        e.preventDefault();
    };
    return QuantityPickerAnimatedComponent;
}());
export { QuantityPickerAnimatedComponent };
